import { render } from "./Sections_Icon.vue?vue&type=template&id=5d872e14&scoped=true"
import script from "./Sections_Icon.vue?vue&type=script&lang=js"
export * from "./Sections_Icon.vue?vue&type=script&lang=js"

import "./Sections_Icon.vue?vue&type=style&index=0&id=5d872e14&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d872e14"]])

export default __exports__